import ClientsPage from './ClientsPage';
import ReceiptsPage from './ReceiptsPage';
import TimecardsPage from './TimecardsPage';
import InvoicesPage from './InvoicesPage';
import JobsPage from './JobsPage';
import SetupPage from './SetupPage';

export {
  ClientsPage,
  InvoicesPage,
  ReceiptsPage,
  TimecardsPage,
  JobsPage,
  SetupPage,
};



// WEBPACK FOOTER //
// ./src/components/admin/index.js